import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({ name: 'upperCase', standalone: true })
@Injectable({providedIn: 'root'})
export class UpperCasePipe implements PipeTransform {
	
	transform(string) {
		return string.toUpperCase();
	}
	
}